import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PAGE_ICONS, PAGE_ROUTES } from 'pages/AnnualUserAccessReview/_const';
import NavCard from '../../components/NavCard';

/**
 * Templated navigation card for Reassignment functionality for User Access Review Directory
 * @param {object[]} props.staffData list of non-employees reporting to logged in user
 * @returns navigation card for reassignment
 */
const ReassignCard = ({ staffData = [] }) => {
	const history = useHistory();

	return staffData.length > 0 ? (
		<NavCard
			title={'Reassign'}
			icon={<PAGE_ICONS.REASSIGN color='secondary' />}
			role={'Administrative'}
			description={'Transfer non-employee(s) to another manager.'}
			onClick={() => history.push(PAGE_ROUTES.REASSIGN)}
		/>
	) : null;
};

ReassignCard.propTypes = {
	staffData: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ReassignCard;
